/* eslint-disable no-param-reassign */
export default (state) => {
  state.assets = {};
};
